<template>
    <div id="app">
        <v-app>
            <router-view/>
        </v-app>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style lang="less">
    @import "../node_modules/bulma/css/bulma.css";
    @import "assets/app";
</style>
